export default {
    greet_text: `Estás a unos pasos de descubrir un mundo lleno de lecturas entretenidas e interactivas.`,
    greet_text_2: 'Te invitamos a completar tu perfil.',
    greet_wellcome: '¡Hola',
    avatar_select: 'Selecciona tu avatar',
    continue: 'Siguiente',
    get_started: 'Comenzar ahora',
    get_started2: 'Iniciar la aventura',
    categories_select: 'Selecciona tus categorías preferidas',
    msg_categories_not_select:
        'Selecciona al menos una categoría para continuar.',
    finish: 'Terminar',
    next_question: 'Siguiente pregunta',
    questions: 'Preguntas:',
    questions2: 'Preguntas',
    finish_msg: '¡Ya casi terminas!',
    previous_diagnostic_msg:
        'Para finalizar, responde este diagnóstico que nos permitirá saber más sobre tus habilidades',
    pre_modal_msg: {
        msg_1: 'Ahora, responde las siguientes preguntas del',
        msg_2: 'diagnóstico.',
    },
    excellent: '¡Excelente',
    msg_thanks: '¡Muchas Gracias!',
    msg_finish: 'Disfruta de esta nueva experiencia.',
    msg_survey_init: 'Ya casi terminamos',
    txt_survey_init: 'Antes de comenzar la lectura, responde a la siguiente encuesta.',
    tutorialTitle: 'Antes de comenzar este <br>diagnóstico, debes saber que:',
    steps_msgs: {
        msg_1:
            'Esta prueba contiene <b>{count} textos</b> y <b>{countQuestions} preguntas</b> de alternativas.',
        msg_2:
            'Las preguntas solo <b>tienen una respuesta correcta.</b> Por lo tanto solo debes seleccionar una alternativa.',
        msg_3: 'Tienes que leer cada texto para responder las preguntas que le siguen.',
        msg_4: 'Para completar el diagnóstico no puedes usar diccionario ni otros apoyos.',
    },
    select_option: 'Por favor, selecciona una de las respuestas para poder continuar.',
    unable_save_diagnostics: 'No se pudieron guardar las respuestas del diagnóstico',
    initialDiagnostic: 'Diagnóstico Inicial',
    beforeYouBegin: 'Antes de comenzar debes saber',
    to_start_Br_first_test:
        'Para dar comenzar en BeeReaders, primero debes hacer una pequeña prueba',
    eight_texts_forty_questions: 'Esta prueba contiene 8 textos y 40 preguntas de alternativas',
    single_selection_questions:
        'Las preguntas tienen una sola respuesta correcta, por lo tanto, debes marcar una sola alternativa',
    readCarefully: 'Tienes que leer cada texto para responder las preguntas que le siguen. Las preguntas solo tienen una respuesta correcta. ',
    noDictionary: 'Para completar el diagnóstico no puedes usar diccionario ni otros apoyos.',
    successDiagnostic: '¡Has terminado el Diagnóstico de Lectura de forma exitosa!',
    readyToBegin: '¡Ahora ya estas listo para empezar!',
    finishDiagnostic: 'Terminar Diagnóstico',
    return: 'Volver',
    question: 'Pregunta',
    of: 'de',
    next_text: 'Próximo texto',
    finish_onboarding: 'Has completado con éxito nuestro emocionante viaje de inicio. Ahora puedes comenzar en <span>BeeReaders</span>.',
    completed: '¡Completado!',
    you_have_more_pending_diagnostics: 'Tienes más diagnósticos pendientes',
}
